/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  titleColor: string;
  valueColor: string;
  iconBgColor: string;
  iconColor: string;
  progress?: number;
  subtitle?: string;
}

const PIStatCard = ({
  title,
  value,
  icon,
  titleColor,
  valueColor,
  iconBgColor,
  iconColor,
  progress,
  subtitle
}: StatCardProps) => (
  <div className="bg-white p-2 rounded-xl border border-slate-200 shadow-sm relative overflow-hidden">
    <div className="flex justify-between items-start mb-2">
      <div>
        <p className={`px-2 py-1 text-[10px] font-black uppercase tracking-widest mb-1 ${titleColor}`}>
          {title}
        </p>
        <p className={`px-2 py-1 text-2xl font-black ${valueColor}`}>
          {value}
        </p>
      </div>
      <div className={`w-8 h-8 rounded-2xl flex items-center justify-center ${iconBgColor}`}>
        <span className={`material-symbols-outlined ${iconColor}`}>
          {icon}
        </span>
      </div>
    </div>

    {progress !== undefined && (
      <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-indigo-500 transition-all duration-500"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    )}

    {subtitle && (
      <p className="px-2 text-[10px] font-bold text-slate-400 uppercase tracking-widest">
        {subtitle}
      </p>
    )}
  </div>
);

export default PIStatCard;
